// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"68b88449","299":"4b02b684","333":"be02fbb0","458":"0902c6b1","478":"654ada5a","629":"c1257d5b","647":"56fb2271","665":"b2d89376","752":"71510fbb","871":"0c28808b","921":"0305d8be","952":"ba0065cc"}[chunkId] + ".chunk.js";
};